import React, { useState, useEffect } from "react";
import { Grid, Stack, Box, GTIWebButton, Avatar, GTIWebStatus, CardContent, GTIWebCardList, HowToReg, Typography } from "@gti-controls-v2/web-core";
import homePageStyles from "../../common/styles/HomePage";
import { formatNumber } from "../../common/utilities/dataFormat";

const ListCardResult = ({ dataSet, handleOpenTicket }) => {
    const styles = homePageStyles;
    const [data, setData] = useState([]);

    useEffect(() => {
        if (dataSet && dataSet.length > 0) {
            setData(dataSet);
        } else {
            setData([])
        }
    }, [dataSet]);

    const CustomIconContent = ({ value, schema }) => {
        const iconStyle = schema?.styleList;

        return (
            <Avatar>
                { value && <HowToReg sx={iconStyle} /> }
            </Avatar>
        );
    };

    const CustomStatusContent = ({ value }) => (
        <GTIWebStatus
            label={value ? "Registrado" : "Sin registrar"}
            status={value}
            datasource={styles.status}
        />
    );

    const CustomCardContent = ({ data }) => (
        <CardContent>
            <Grid container sx={styles.cardGrid}>
                <Stack direction="row" spacing={4} sx={styles.stackRow}>
                    <Stack direction="column" sx={styles.stackColumn}>
                        <Box sx={styles.boxMargin}>
                            <Typography sx={styles.typography}>CURP:</Typography>
                            <Typography variant="body2">{data.curp}</Typography>
                        </Box>
                        <Box sx={styles.boxMargin}>
                            <Typography sx={styles.typography}>Número de Empleado:</Typography>
                            <Typography variant="body2">{data.empNumero}</Typography>
                        </Box>
                        <Typography sx={styles.typography}>Teléfono +ORDEN:</Typography>
                            <Typography variant="body2">{formatNumber(data?.cel) ?? 'No registrado'}</Typography>
                    </Stack>

                    <Stack direction="column" sx={styles.stackColumn}>
                        <Box sx={styles.boxMargin}>
                            <Typography sx={styles.typography}>Nombre:</Typography>
                            <Typography variant="body2">{data.nombre}</Typography>
                        </Box>
                        <Box sx={styles.boxMargin}>
                            <Typography sx={styles.typography}>Empresa:</Typography>
                            <Typography variant="body2">{data.empresaNombre}</Typography>
                        </Box>
                        <Box sx={styles.boxMargin}>
                            <Typography sx={styles.typography}>Correo +ORDEN:</Typography>
                            <Typography variant="body2">{data?.email ?? 'No registrado'}</Typography>
                        </Box>
                    </Stack>

                    <Stack direction="column" sx={styles.stackColumn}>
                        <Box sx={styles.boxMargin}>
                            <Typography sx={styles.typography}>Fecha de Nacimiento:</Typography>
                            <Typography variant="body2">{data.fechaNacimiento}</Typography>
                        </Box>
                        <Box sx={styles.boxMargin}>
                            <Typography sx={styles.typography}>Estado de Nacimiento:</Typography>
                            <Typography variant="body2">{data.estadoNacimiento}</Typography>
                        </Box>
                        <Box sx={styles.boxMargin}>
                            <GTIWebButton
                                name="createTicket"
                                type="submit"
                                text="Abrir Ticket"
                                sx={styles.btnContinue}
                                onClick={(e) => handleOpenTicket(e, data)}
                            />
                        </Box>
                    </Stack>
                </Stack>
            </Grid>
        </CardContent>
    );

    const headersSchema = {
        "icon": {
            "field": "isUserPortal",
            "styleList": {
                fontSize: 30
            }
        },
        "title": {
            "field": "nombre",
        },
        "subtitle": {
            "field": "curp",
            "domain": "nombre"
        },
        "status": {
            "field": "isUserPortal",
        },
        "identityColumns": ["id"],
    };

    return (
        <Grid>
            <GTIWebCardList
                headersSchema={headersSchema}
                cards={data}
                iconContent={<CustomIconContent />}
                statusContent={<CustomStatusContent />}
                detailPanelContent={<CustomCardContent />}
            />
        </Grid>
    );
};

export default ListCardResult;